import React from 'react';
import { RateCalculatorTemplate } from 'themes/modules/rate-calculator/pages';
import { RateCalculatorViewStore } from 'modules/rate-calculator/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new RateCalculatorViewStore(rootStore), 'rateCalculatorViewStore')
class RateCalculator extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <RateCalculatorTemplate {...this.props} viewStore={this.props.rateCalculatorViewStore} />;
	}
}

export default RateCalculator;
